var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrimbleRHorizRgbBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Art_Black",
    "data-name": "Art Black",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 444.68 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.85,87.13v-62H93V11.21h62.57v14h-23v62Z",
    fill: "#0063a3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.9,87.13V32.74h16.52v8.84h.1c3-4.62,8.21-10.26,18.47-10.26h.51V46c-.61-.11-3.49-.31-4.51-.31a18.27,18.27,0,0,0-14.57,7.49v34Z",
    fill: "#0063a3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.72,25V11.72h16.62V25Zm.11,62.17V32.44h16.41V87.13Z",
    fill: "#0063a3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.7,87.13V32.44h16.51v8.62c3.29-4.31,9.34-9.74,18-9.74,9.13,0,13.44,3.79,15,9.74,3.28-4.2,9.44-9.74,18-9.74,11.08,0,16,7,16,16.72V87.13H272.69V52.45c0-4.92-1.13-7.49-5.95-7.49-4.1,0-7.39,2.26-11,5.44V87.13H239.25V52.45c0-4.92-1.13-7.49-6-7.49-4.1,0-7.38,2.26-11.08,5.44V87.13Z",
    fill: "#0063a3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312,80.66v6.47H295.45V11.21H312V40.86c3.59-5,8.72-9.54,16.82-9.54,12.42,0,21,9.54,21,28.41S341.11,88,328.59,88C321.2,88,316.07,85.28,312,80.66Zm21.34-20.82c0-9.13-3.18-14.88-10.57-14.88-4.21,0-8,2.57-10.77,5.34V70.51c3.59,3.38,6.56,5,11,5C329.82,75.53,333.31,69.79,333.31,59.84Z",
    fill: "#0063a3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.94,87.13V11.21h16.41V87.13Z",
    fill: "#0063a3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.47,59.84c0-21.24,16.21-28.52,27.49-28.52S429.1,37,429.1,61.79v2.46H392.88c.83,9,5.85,12.51,12.73,12.51a25.16,25.16,0,0,0,16.21-6.56l6.36,9.85c-6.36,5.44-14.26,8.21-23.8,8.21C390.11,88.26,376.47,81,376.47,59.84Zm37.86-5.34c-.82-7.69-4.31-11.39-10.47-11.39-5.13,0-9.54,3.39-10.77,11.39Z",
    fill: "#0063a3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432.22,81a6.19,6.19,0,0,1,6.26-6.26A6.26,6.26,0,1,1,432.22,81Zm11.38,0a5.14,5.14,0,1,0-5.12,5.23A5.12,5.12,0,0,0,443.6,81Zm-7.55-3.56h2.56c1.62,0,2.56.7,2.56,2.1a1.84,1.84,0,0,1-1.34,1.94l1.48,2.81h-1.43l-1.38-2.62h-1.08v2.62h-1.37Zm2.48,3.18c.84,0,1.3-.27,1.3-1s-.46-1-1.33-1h-1.08v2Z",
    fill: "#0063a3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19,76.41V100L26.71,88.16A39.1,39.1,0,0,1,6.19,76.41Z",
    fill: "#0063a3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,11.74,6.19,0V23.45A39.33,39.33,0,0,1,26.56,11.74Z",
    fill: "#0063a3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8,50,72.29,38.16a39.27,39.27,0,0,1-.06,23.72Z",
    fill: "#0063a3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7,17.92c2.94-.65,9.05,0,12.28.89a18.68,18.68,0,0,1,10.37-3.45A41.12,41.12,0,0,0,19.7,17.92Z",
    fill: "#0063a3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,60.84a53.07,53.07,0,0,0-3.21-13.13c-7,3.18-15.72,1.13-21.53-3.9A95.93,95.93,0,0,0,22.62,58.32C32.47,66.35,48.67,68.46,58.79,60.84Z",
    fill: "#0063a3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.23,59.09C8.55,50.19,5.52,37.22,8.3,27.25a35,35,0,0,0,2,47.47A63.4,63.4,0,0,1,17.23,59.09Z",
    fill: "#0063a3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54,43.94a47.18,47.18,0,0,0-7-10.78A80.73,80.73,0,0,0,37,40.93C42.26,45.3,49.14,46.16,54,43.94Z",
    fill: "#0063a3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.47,27.72a36.33,36.33,0,0,1,7.62-4.23c-5.56-5.62-14.5-5.47-18.39-3A37.17,37.17,0,0,1,47.47,27.72Z",
    fill: "#0063a3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,62c-4.32,7.47-5.9,13-6.48,15.87A35,35,0,0,0,57.1,77a30,30,0,0,0,2-11.33C47.14,72.79,30.66,70.07,20.4,62Z",
    fill: "#0063a3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,41.45c3.83-4,3.06-10.84.15-14.78a29.6,29.6,0,0,0-7.13,4.18A52.73,52.73,0,0,1,57.4,41.45Z",
    fill: "#0063a3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64,32.85a14.1,14.1,0,0,1-4.84,12.59A57.37,57.37,0,0,1,62.49,57.2C67.74,50.38,67.58,40.64,64,32.85Z",
    fill: "#0063a3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.16,37.9A83.13,83.13,0,0,1,44,30.11a33.17,33.17,0,0,0-10.82-6.59C29.92,27.89,30.92,33.53,34.16,37.9Z",
    fill: "#0063a3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.12,62.69a49.42,49.42,0,0,1-.43,8.88A35.37,35.37,0,0,0,70,47.07,26.82,26.82,0,0,1,63.12,62.69Z",
    fill: "#0063a3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1,22.28a28.42,28.42,0,0,0-13.9.09c-6.89,9.77-3.69,24.08,4.33,33A100.8,100.8,0,0,1,31.18,40.79C27.1,35.72,25.48,27.89,29.1,22.28Z",
    fill: "#0063a3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrimbleRHorizRgbBlue);
export default __webpack_public_path__ + "static/media/TrimbleR-Horiz-RGB-Blue.6e80a112397166921337b1d722ecd43d.svg";
export { ForwardRef as ReactComponent };